import { render, staticRenderFns } from "./InventarioSubBanner.vue?vue&type=template&id=10c58f3f&scoped=true"
import script from "./InventarioSubBanner.vue?vue&type=script&lang=js"
export * from "./InventarioSubBanner.vue?vue&type=script&lang=js"
import style0 from "./InventarioSubBanner.vue?vue&type=style&index=0&id=10c58f3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c58f3f",
  null
  
)

export default component.exports